import { httpClientOmni } from "@/libraries";

export default {
  async sendBroadcastLine(payload) {
    return await httpClientOmni.post("broadcast-by-channel/send-line", {
      ...payload,
    });
  },
};
